import * as brandColors from '../../../../../utils/brand-colors';

export default () => ({ container: { background: 'white' } });

export const inlineStyles = {
  caption: {
    display: 'block',
    textOverflow: 'ellipsis',
    width: '100%',
    overflow: 'auto',
    color: brandColors.grey.main,
  },
  name: {
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    overflow: 'auto',
    display: 'flex',
    alignItems: 'center',
  },
  nameContainer: { width: '100%' },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    position: 'relative',
    left: -16,
  },
  chevron: { color: brandColors.grey[300] },
  accentColor: { color: brandColors.grey.main },
  archivedIcon: {
    color: brandColors.grey.main,
    fontSize: '16px',
  },
};
